import { EPaymentPlan, EWorksheetDecision, getEPaymentPlanList } from '@if/core/types'
import * as yup from '@if/core/yup'
import { BaseWorksheetDto, baseWorksheetFundingThresholdExtendSchema, baseWorksheetSchema } from './BaseWorksheetSchema'
import { ParameterizedMessage } from './ParameterizedMessage'

export const IFinanceBaseWorksheetSchema = yup
  .object({
    amountRequested: yup.double().positive(),
    includeInsurance: yup.boolean().default(false),
    isHighEstimate: yup.boolean().default(false),
    highEstimateExplainedToClient: yup.boolean().default(false),
    paymentPlanId: yup.mixed<EPaymentPlan>().required().oneOf(getEPaymentPlanList()),
  })
  .concat(baseWorksheetSchema)

export type IFinanceBaseWorksheet = yup.InferType<typeof IFinanceBaseWorksheetSchema> &
  BaseWorksheetDto & {
    insuranceFee: number
    insuranceTax: number
    insuranceRate: number
    insuranceCompanyId: string | null
    includeProtection: boolean
    protectionPlanAmount: number
    protectionCompanyId: string | null
    totalInterestAmount: number
  }

export type IFinanceBaseWorksheetRevision = IFinanceBaseWorksheet & {
  CurrentRevisionId: string
}

export const IFinanceBaseWorksheetDecisionDTOSchema = yup.object({
  creditApplicationId: yup.string(),
  otherReason: yup.string().default('').nullable(),
  decision: yup.mixed<EWorksheetDecision>(),
  fundingThresholdExtend: baseWorksheetFundingThresholdExtendSchema
    .notRequired()
    .nullable()
    .default(baseWorksheetFundingThresholdExtendSchema.getDefault()),
  refusalMessages: yup.mixed<ParameterizedMessage[]>().default([]),
  versionTag: yup.string(),
})

export type IFinanceBaseWorksheetDecisionDTO = yup.InferType<typeof IFinanceBaseWorksheetDecisionDTOSchema>
